import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar";
import PageHeader from "../../components/PageHeader";
import Footer from "../../components/Footer";
import Button from "../../components/Button";
import Staff1 from "../../image/faculty/staff1.jpg";
import ProgramOfferCard from "../../components/ProgramOfferCard";
import AdmissionStep from "../../components/AdmissionStep";
import AdmissionAccordion from "../../components/AdmissionAccordion";
export default function AdmissionPage() {
  const [isAdmissionRequirements, setIsAdmissionRequirements] =
    useState("basicEducation");
  useEffect(() => {
    // Smooth scrolling to the section if the URL contains a hash
    if (window.location.hash) {
      const targetId = window.location.hash;
      const targetElement = document.querySelector(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  }, []);
  return (
    <div>
      <Navbar />
      <main className="bg-secondary-light">
        {/* section 1 */} {/* title page */}
        <PageHeader
          pageTitle={"ADMISSION"}
          description={
            " Read more about us. Our history, mission, vision and many other you might love."
          }
        />
        {/*  Admission Process   */}
        <div className=" responsive-padding ">
          <div className="my-5 md:my-8 flex flex-col gap-3">
            <h1 className=" font-montserrat font-bold text-2xl md:text-3xl laptopSm:text-4xl text-text-normal">
              Admission Process
            </h1>
            <p className="font-notoSans font-light text-sm leading-6  text-primary-normal">
              Welcome to the JMIF Admission Process! We are excited to guide you
              through each step as you join our vibrant school community. Here’s
              how to apply:
            </p>
          </div>
          {/* admission step */}
          <div>
            <AdmissionStep
              stepNumber={"01"}
              title={"ADMISSION STEP 1"}
              headingText={"HEADING TEXT"}
              listItems={
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent id nibh vel massa efficitur fermentum non ac orci. In sed libero vitae eros fermentum ultricies."
              }
            />{" "}
            <AdmissionStep
              stepNumber={"02"}
              title={"ADMISSION STEP 1"}
              headingText={"HEADING TEXT"}
              listItems={
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent id nibh vel massa efficitur fermentum non ac orci. In sed libero vitae eros fermentum ultricies."
              }
            />{" "}
            <AdmissionStep
              stepNumber={"03"}
              title={"ADMISSION STEP 1"}
              headingText={"HEADING TEXT"}
              listItems={
                "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent id nibh vel massa efficitur fermentum non ac orci. In sed libero vitae eros fermentum ultricies."
              }
            />
          </div>
          {/* admission Requirements */}
          <div className="mt-8">
            <h1 className=" font-montserrat font-bold text-2xl md:text-3xl laptopSm:text-4xl text-text-normal">
              ADMISSION REQUIREMENTS{" "}
            </h1>
            <div className="my-4 border-b-2 border-grey-lighActive font-montserrat text-base text-grey-normal flex gap-x-4">
              <span
                onClick={() => setIsAdmissionRequirements("basicEducation")}
                className={`font-semibold border-b-2 ${
                  isAdmissionRequirements === "basicEducation"
                    ? "border-b-text-normal text-text-normal"
                    : "border-b-grey-lighActive"
                } hover:text-text-normal hover:border-b-text-normal w-auto cursor-pointer p-1 -mb-[1.5px] inline-block z-10`}
              >
                Basic Education
              </span>
              <span
                onClick={() => setIsAdmissionRequirements("college")}
                className={`font-semibold border-b-2 ${
                  isAdmissionRequirements === "college"
                    ? "border-b-text-normal text-text-normal"
                    : "border-b-grey-lighActive"
                } hover:text-text-normal hover:border-b-text-normal w-auto cursor-pointer p-1 -mb-[1.5px] inline-block z-10`}
              >
                Tertiary Education
              </span>
            </div>

            <div className="grid grid-cols-1 laptopSm:grid-cols-2 gap-5 my-7">
              {isAdmissionRequirements === "basicEducation" ? (
                <div className="w-full rounded-[50px] p-6 border-[0.5] border-primary-normal bg-text-light">
                  <p className=" font-notoSans font-light text-xs tracking-[0.04em] leading-[30px] ">
                    To complete your application to JMIF, please ensure you have
                    the following documents:
                  </p>
                  <ul className="list-disc font-notoSans font-light text-xs tracking-[0.04em] leading-[30px] pl-6">
                    <li>
                      Photocopy of PSA Birth Certificate (along with the
                      original copy)
                    </li>
                    <li>Grade Card (Original and Photocopy)</li>
                    <li>Certificate of Good Moral</li>
                    <li>2pcs of 2x2 recent picture</li>
                    <li>1pc Long Brown Envelope</li>
                    <li>Form 137 (Submitted before 1st Quarter)</li>
                  </ul>
                </div>
              ) : (
                <>
                  <div className="w-full rounded-[50px] p-6 border-[0.5] border-primary-normal bg-text-light">
                    <h6 className="font-montserrat font-medium text-base text-black mb-3">
                      FOR FRESHMEN
                    </h6>
                    <p className=" font-notoSans font-light text-xs tracking-[0.04em] leading-[30px] ">
                      (Senior High School and Non Senior High School Graduates)
                      The admission to JMIF will be based on the applicant's
                      academic records and all other pertinent documents
                      indicate below.
                    </p>
                    <ul className="list-disc font-notoSans font-light text-xs tracking-[0.04em] leading-[30px] pl-6">
                      <li>Certificate of Live Birth PSA (Photocopy)</li>
                      <li>Certificate of Marriage (PSA), if married</li>
                      <li>Senior High School CARD (Original Copy)</li>
                      <li>
                        Certificate of Good Moral Character (Original Copy)
                      </li>
                      <li>
                        Two pieces of 2x2 recent ID Picture (White background)
                      </li>
                    </ul>
                  </div>
                  <div className="w-full rounded-[50px] p-6 border-[0.5] border-primary-normal bg-text-light">
                    <h6 className="font-montserrat font-medium text-base text-black mb-3">
                      FOR TRANSFEREES{" "}
                    </h6>

                    <ol className=" list-decimal font-notoSans font-light text-xs tracking-[0.04em] leading-[30px] pl-3">
                      <li>Certificate of Live Birth PSA (Photocopy)</li>
                      <li>Certificate of Marriage (PSA), if married</li>
                      <li>Senior High School CARD (Original Copy)</li>
                      <li>
                        Certificate of Good Moral Character (Original Copy)
                      </li>
                      <li>
                        Two pieces of 2x2 recent ID Picture (White background)
                      </li>
                    </ol>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        {/* SCHOLARSHIP PROGRAM */}
        <section
          id="scholarship-program"
          className="bg-[#ffffff] responsive-padding py-8 md:py-10"
        >
          <h1 className=" font-montserrat font-bold text-2xl md:text-3xl laptopSm:text-4xl text-text-normal mb-5 md:mb-8">
            SCHOLARSHIP & FINANCIAL AID{" "}
          </h1>
          <div className="flex flex-col gap-x-8 md:gap-x-11">
            <AdmissionAccordion />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
